// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"08f21276","60":"e6150588","85":"d9fdda00","113":"3e427044","165":"8f3d03be","235":"e65b4323","277":"7a62fbf5","579":"01ae172d","640":"e2c58820","710":"a4a32baf","762":"ae81c6f5","787":"f59af263"}[chunkId] + ".chunk.js";
};